export default {
    title: "Recomendaciones del asesor",
    noItems: "Sin recomendaciones"
}